import { FC, useEffect, useState } from "react";
import { customerPortal, shared, types } from "@vilocnv/allsetra-core";
import useGeozoneDetailPage from "./useGeozoneDetailPage";
import { MarkerObjectIcon } from "assets/icons";
const { LeftRightLayoutContainer, LeftSection, RightSection } = shared;
const { geozones } = customerPortal;
const {
  GeozoneDetailListHeader,
  GeozoneDetailObjectsList,
  GeozoneDetailObjectsListItem,
  GeozoneDetailSearchInput,
  GeozoneDetailMap
} = geozones;

const GeozoneDetailPage: FC = () => {
  const [isMountingComponent, setIsMountingComponent] = useState(true);
  const [mounted, setMounted] = useState(false);
  const {
    markers,
    geozoneObjectsMarkers,
    translator,
    theme,
    selectedGeozone,
    onEditGeozoneClick,
    geozoneObjects,
    navigate,
    selectedTooltipMarker,
    handleMarkerMouseOver,
    handleMarkerMouseOut,
    handleShowInfoWindowClick,
    handleCloseInfoWindowClick,
    showMarkers,
    toggleShowMarkers,
    selectedObject,
    handleMapLoad,
    handleObjectClick,
    isLoadingSelectedGeozone,
    isLoadingGeozoneObjects
  } = useGeozoneDetailPage();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;

    setIsMountingComponent(false);
  }, [mounted]);

  const isLoading =
    isMountingComponent ||
    !!isLoadingGeozoneObjects ||
    !!isLoadingSelectedGeozone;

  return (
    <>
      <LeftRightLayoutContainer>
        <LeftSection>
          <GeozoneDetailListHeader
            isLoading={isLoading}
            geozone={selectedGeozone}
            onEditGeozoneClick={onEditGeozoneClick}
            theme={theme}
            translator={translator}
            buttonText={translator("titles.addGeozone")}
            onBackButtonClick={() => navigate("/dashboard/geozones")}
          />
          <GeozoneDetailSearchInput
            placeholder={translator("common.search")}
            isLoading={isLoading}
          />
          <GeozoneDetailObjectsList
            translator={translator}
            isLoading={isLoading}
            objects={geozoneObjects || []}
          >
            {(object: types.IObject, index: number) => (
              <GeozoneDetailObjectsListItem
                isLoading={isLoading}
                index={index}
                listLength={geozoneObjects.length}
                object={object}
                onClick={handleObjectClick}
              />
            )}
          </GeozoneDetailObjectsList>
        </LeftSection>
        <RightSection>
          <GeozoneDetailMap
            isLoadingGeozones={isLoading}
            onMapLoad={handleMapLoad}
            handleCloseInfoWindowClick={handleCloseInfoWindowClick}
            geozones={selectedGeozone ? [selectedGeozone] : []}
            markers={markers}
            geozoneObjectsMarkers={geozoneObjectsMarkers}
            showMarkers={showMarkers}
            selectedObject={selectedObject}
            selectedTooltipMarker={selectedTooltipMarker}
            onShowMarkersClick={toggleShowMarkers}
            onMarkerMouseOver={handleMarkerMouseOver}
            onMarkerMouseOut={handleMarkerMouseOut}
            onShowInfoWindowClick={handleShowInfoWindowClick}
            translatorFn={translator}
            navigateFn={navigate}
            showMarkersIcon={<MarkerObjectIcon />}
            tooltipText={translator("common.showObjects")}
          />
        </RightSection>
      </LeftRightLayoutContainer>
    </>
  );
};

export default GeozoneDetailPage;
